import "@hotwired/turbo-rails"

import "@tabler/core/dist/js/tabler";
